module.exports = __webpack_public_path__ + "assets/img/00110.0a940048.png";